module.exports = __webpack_public_path__ + "static/screens-c9c6d93213f63a9737704a051cf42a9a.jpg";